import Router from 'vue-router'

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  strict: true,
  routes: [
    {
      path: '/',
      alias: '/buddies',
      name: 'users',
      component: () => import('@/views/users')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('@/views/contacts')
    },
    {
      path: '/queues',
      name: 'queues',
      component: () => import('@/views/queues'),
      redirect: '/queues/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () => import('@/components/queues'),
          name: 'queues-dashboard'
        },
        {
          path: 'reports',
          component: () => import('@/components/queues/reports'),
          name: 'queues-reports'
        }
      ]
    },
    {
      path: '/queues/dashboard',
      name: 'queues_dashboard'
    },
    {
      path: '/conferences',
      name: 'conferences',
      component: () => import('@/views/conferences')
    },
    {
      path: '/video_conferences',
      name: 'video-conferences',
      component: () => import('@/views/video_conferences')
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: () => import('@/views/announcements')
    },
    {
      path: '/parking/:extension?',
      name: 'parking',
      sensitive: true,
      props: true,
      component: () => import('@/views/parking')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings'),
      redirect: '/settings/phone_status',
      children: [
        {
          path: 'phone_status',
          component: () => import('@/components/settings/drawer/pages'),
          name: 'settings-phone-status'
        },
        {
          path: 'devices',
          component: () => import('@/components/settings/drawer/pages/devices'),
          name: 'settings-devices'
        },
        {
          path: 'account',
          component: () => import('@/components/settings/drawer/pages/account'),
          name: 'settings-account'
        },
        {
          path: 'softphone',
          component: () => import('@/components/settings/drawer/pages/softphone'),
          name: 'settings-softphone'
        },
        {
          path: 'emergency',
          component: () => import('@/components/settings/drawer/pages/emergency'),
          name: 'settings-emergency'
        },
        {
          path: 'notifications',
          component: () => import('@/components/settings/drawer/pages/notifications'),
          name: 'settings-notifications'
        },
        {
          path: 'click_to_dial',
          component: () => import('@/components/settings/drawer/pages/click_to_dial'),
          name: 'settings-click-to-dial'
        },
        {
          path: 'call_screen_pop',
          component: () => import('@/components/settings/drawer/pages/call_screen_pop'),
          name: 'settings-call-screen-pop'
        },
        {
          path: 'stun_servers',
          component: () => import('@/components/settings/drawer/pages/stun_servers'),
          name: 'settings-stun-servers'
        }
      ]
    },
    {
      path: '/settings/phone_status',
      name: 'settings_phone_status'

    },
    {
      path: '/cdrs',
      name: 'cdrs',
      component: () => import('@/views/cdrs')
    },
    {
      path: '/clusterpbx_callback',
      name: 'oauth2',
      component: () => import('@/views/oauth2')
    },
    {
      path: '/embedded_login',
      name: 'embedded_login',
      component: () => import('@/views/embedded_login')
    },
    {
      path: '/chat/:roomType?/:roomId?/:extraPath?',
      name: 'chats',
      sensitive: true,
      props: true,
      component: () => import('@/views/chat')
    },
    {
      path: '/voicemails/:folder?/:id?',
      name: 'voicemails',
      sensitive: true,
      props: true,
      component: () => import('@/views/voicemails')
    },
    {
      path: '/dialer/:phoneNumber?',
      name: 'dialer',
      component: () => import('@/views/dialer')
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: () => import('@/views/unsupported')
    },
    {
      path: '/signout',
      name: 'signout',
      component: () => import('@/views/signout')
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/access_denied')
    }
  ]
})
